export const GRID_FRAME_HEADER = 'X-Grid-Frame'

/**
 * True when this document is nested in another window. Cross-origin parents
 * still compare as not-self; reading `window.top` does not throw.
 */
export const isEmbeddedFrame = () => {
  try {
    return typeof window !== 'undefined' && window.self !== window.top
  } catch {
    return true
  }
}

export const embedFrameHeaders = () => (
  isEmbeddedFrame()
    ? { [GRID_FRAME_HEADER]: '1' }
    : {}
)
